<template>
  <div class="dropdown" data-type="click" ref="groupbuttons">
    <button class="btn clickable">Set state</button>
    <div class="menu">
      <div
        class="item"
        v-for="(item, index) in actionButtons"
        :disabled="item.isDisabled ? true : false"
        :key="index"
        @click="item.action">
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
import { Dropdown } from '@eds/vanilla';
export default {
  data() {
    return {
      groupbuttons: Dropdown,
    };
  },

  props: {
    actionButtons: {
      type: Array,
      required: true,
    },
  },

  mounted() {
    this.initGroupbuttons();
  },

  methods: {
    initGroupbuttons() {
      const groupbuttons = this.$refs.groupbuttons;
      this.groupbuttons = new Dropdown(groupbuttons);

      this.groupbuttons.init();
    },
  },
};
</script>

<style>
</style>